import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useParams, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Chatbot from "./components/Chatbot";
import WhatsAppFloat from "./components/WhatsAppFloat";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import WhyAlbl from "./pages/WhyAlbl";
import Markets from "./pages/Markets";
import Insights, { Article } from "./pages/Insights";
import Contact from "./pages/Contact";
import MetroMarket from "./pages/MetroMarket";
import HindiHome from "./pages/HindiHome";
import HindiContact from "./pages/HindiContact";
import HindiServices from "./pages/HindiServices";
import HindiWhyAlbl from "./pages/HindiWhyAlbl";
import HindiInsights, { HindiArticle } from "./pages/HindiInsights";
import HindiAbout from "./pages/HindiAbout";
import HindiMarkets from "./pages/HindiMarkets";

const HI_META = {
    "/hi": "ALBL Communications — नर्मदापुरम, इतारसी और आसपास के बाज़ारों के बिज़नेस के लिए ब्रांड, मार्केटिंग और सेल्स ग्रोथ पार्टनर।",
    "/hi/about": "ALBL क्यों बना — बड़े ब्रांड्स के प्रोफ़ेशनल अनुभव पर बनी, लोकल बिज़नेस के लिए गंभीर मार्केटिंग सोच।",
    "/hi/services": "ALBL की सेवाएँ — ब्रांड स्ट्रैटेजी, रिटेल और ट्रेड मार्केटिंग, डिजिटल ग्रोथ, कस्टमर एक्विज़िशन और सेल्स ग्रोथ।",
    "/hi/why-albl": "आपको एक और मार्केटिंग एजेंसी नहीं चाहिए — ALBL बिज़नेस से शुरुआत करती है, पैकेज से नहीं।",
    "/hi/markets": "ALBL के बाज़ार — दिल्ली, भोपाल, इंदौर, नर्मदापुरम, इतारसी और आसपास के इलाके।",
    "/hi/insights": "नर्मदापुरम, इतारसी और आसपास के बाज़ारों के लिए मार्केटिंग और सेल्स ग्रोथ के व्यावहारिक लेख।",
    "/hi/contact": "ALBL से संपर्क करें — कॉल 9540088845, WhatsApp या enquiry फ़ॉर्म। ग्रोथ ऑडिट लें।",
};

const EN_META = "ALBL Communications helps businesses in Narmadapuram, Itarsi and nearby markets grow through brand marketing, retail, digital marketing, customer acquisition and sales-focused strategies.";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
        document.documentElement.lang = pathname.startsWith("/hi") ? "hi" : "en";
        const desc = HI_META[pathname];
        document
            .querySelector('meta[name="description"]')
            ?.setAttribute("content", desc || (pathname.startsWith("/hi") ? HI_META["/hi"] : EN_META));
    }, [pathname]);
    return null;
};

const ArticleRoute = () => {
    const { slug } = useParams();
    return <Article key={slug} slug={slug} />;
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <Navbar />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/why-albl" element={<WhyAlbl />} />
                    <Route path="/markets" element={<Markets />} />
                    <Route path="/insights" element={<Insights />} />
                    <Route path="/insights/:slug" element={<ArticleRoute />} />
                    <Route path="/markets/:city" element={<MetroMarket />} />
                    <Route path="/hi" element={<HindiHome />} />
                    <Route path="/hi/markets" element={<HindiMarkets />} />
                    <Route path="/hi/about" element={<HindiAbout />} />
                    <Route path="/hi/services" element={<HindiServices />} />
                    <Route path="/hi/why-albl" element={<HindiWhyAlbl />} />
                    <Route path="/hi/insights" element={<HindiInsights />} />
                    <Route path="/hi/insights/:slug" element={<HindiArticle />} />
                    <Route path="/hi/markets/:city" element={<MetroMarket lang="hi" />} />
                    <Route path="/hi/contact" element={<HindiContact />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
                <Footer />
                <WhatsAppFloat />
                <Chatbot />
                <Toaster position="top-center" richColors />
            </BrowserRouter>
        </div>
    );
}

export default App;
